import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import Navbar from '../components/Navbar';
import ProductCard from '../components/ProductCard';
import PromoSlot from '../components/PromoBanner';
import { Tag } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function SalePage() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.title = 'Sale | Market @ Buzzzillion';
    axios.get(`${API}/products`, { params: { sale: true, limit: 100 } })
      .then(r => setProducts(r.data.products))
      .catch(() => setProducts([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="store-page relative">
      <Navbar />
      <div className="relative z-10 max-w-7xl mx-auto px-6 pt-8 pb-20">
        <h1 className="text-4xl font-black text-ink mb-2 flex items-center gap-3" style={{ fontFamily: 'Outfit, sans-serif' }}>
          <Tag className="w-8 h-8 text-honey-600" /> On Sale
        </h1>
        <p className="text-ink/55 mb-8">Limited-time prices. Grab them while they last.</p>
        <PromoSlot placement="home" className="mb-10" />
        {loading ? (
          <div className="flex justify-center py-20"><div className="w-8 h-8 border-2 border-honey border-t-transparent rounded-full animate-spin" /></div>
        ) : products.length === 0 ? (
          <div className="text-center py-20">
            <p className="text-ink/60 mb-6">Nothing is on sale right now. Check back soon!</p>
            <Link to="/" className="btn-primary">Shop everything</Link>
          </div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5">
            {products.map(p => <ProductCard key={p.id} product={p} />)}
          </div>
        )}
      </div>
    </div>
  );
}
